import React, { Component } from 'react'
import './contact.scss'
import contact_wx from '../assets/img/contact-wx.jpg'
import Footer from '../component/Footer/footer'
import ReactQMap from 'react-qmap';
import QQMap from 'qqmap';
class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    componentDidMount() {
    }
    //地图初始化的方法
    initQQMap = () => {
        QQMap.init('GMCBZ-ZFXRD-WKD4J-PQETH-IPZZS-XKFTA', () => {
        });
    }

    renderMap = () => {
    }

    render() {
        return (
            <div>
                <ReactQMap
                    center={{ latitude: 30.189636, longitude: 120.179461 }}
                    mySpot={{ latitude: 30.189636, longitude: 120.179461 }}
                    initialOptions={{ zoomControl: true, mapTypeControl: true }}
                    apiKey="GMCBZ-ZFXRD-WKD4J-PQETH-IPZZS-XKFTA"
                    style={{ height: 600 }}    
                />

                <div className="contact_content">
                    <div className="title">联系我们</div>
                    <div className="wrap">
                        <div className="left">
                            <p className='blank'>杭州希格斯投资管理有限公司</p>
                            <p className='blank'>浙江省杭州市滨江区长河街道建业路599号华业发展中心30层3003室</p>
                            <p>+86-571-8724-8912</p>
                        </div>
                        <div className="right">
                            <img alt='img1' src={contact_wx} />
                        </div>
                    </div>
                </div>
                <Footer type={2}></Footer>
            </div>
        )
    }
}

export default Contact